<script setup>
import { RouterView } from 'vue-router'
import TheFooter from './components/TheFooter.vue'
import TheMenu from './components/TheMenu.vue'

import { useTextStore } from './stores/texts'
import { provide } from 'vue'
import { setupClients } from './lohnrechner'
import { ref } from 'vue'
import { watch } from 'vue'
import { inject } from 'vue'
import { onMounted } from 'vue'

const store = useTextStore()

setupClients()

const displayKeys = ref(false)

if (window.document.location.search.includes('displayKeys')) {
  displayKeys.value = true
}

const fetchTexts = async () => {
  store.loading = true
  try {
    const response = await fetch(
      import.meta.env.VITE_API_HOST + `/texts/?language=${store.language}`,
      {
        mode: 'cors',
        credentials: 'same-origin',
        method: 'GET'
      }
    )
    let data = await response.json()
    store.texts = data.texts
    store.loading = false
  } catch (error) {
    console.error(error)
  }
}

const $vueform = inject('$vueform')

const setLanguage = (lang) => {
  store.language = lang
  if ($vueform && $vueform.value) {
    $vueform.value.i18n.locale = lang.split('-')[0]
  }
  fetchTexts()
}

const getLanguage = () => {
  return store.language.value
}

onMounted(() => {
  const lang = document.documentElement.lang || 'de-ch'
  setLanguage(lang)
})

const t = (key) => {
  if (displayKeys.value) {
    return key
  }
  if (store.loading) {
    return ''
  }
  if (store.texts[key]) {
    return store.texts[key]
  }
  return key
}

const title = ref('')

function setDocTitle(subtitle) {
  title.value = subtitle
}

watch(
  () => [title.value, store.loading],
  () => {
    document.title = title.value ? t(title.value) + ' - ' + t('site-title') : t('site-title')
  }
)

provide('setLanguage', setLanguage)
provide('getLangauge', getLanguage)
provide('setTitle', setDocTitle)

provide('t', t)
</script>

<template>
  <TheMenu />

  <main>
    <RouterView />
  </main>

  <footer>
    <TheFooter />
  </footer>
</template>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
